class BezierCurve {
  getPoint(t, p1, p2, p3) {
    let t_d = 1.0 - t;
    let t_square = t * t;
    let t_d_square = t_d * t_d;
    let x = t_d_square * p1.x + 2 * t_d * t * p2.x + t_square * p3.x;
    let y = t_d_square * p1.y + 2 * t_d * t * p2.y + t_square * p3.y;
    return this.createPoint(x, y);
  }

  createPoint(x, y) {
    return { x, y };
  }

  getPoints(steps, p1, p2, p3) {
    const points = [];
    const time_step = 1 / steps;
    let step = 0;
    points.push(p1);

    for (let num = 2; num < steps; num++) {
      step += time_step;
      points.push(this.getPoint(step, p1, p2, p3));
    }
    points.push(p3);
    return points;
  }

}

export const bezierCurve = new BezierCurve();
